import { Injectable } from '@angular/core';
import { DnextRole } from 'src/app/feature/doctors-next.service';

@Injectable({
  providedIn: 'root',
})
export class DoctorsNextRegisterStateService {
  inputStep: 'base' | 'speciality' | 'confirm' = 'base';

  roles: {
    key: DnextRole;
    label: string;
  }[] = [
    { key: 'doctor', label: '医師' },
    { key: 'pharmacist', label: '薬剤師' },
    { key: 'nurse', label: '看護師' },
    { key: 'dietitian', label: '栄養士・管理栄養士' },
    { key: 'medical_assistant', label: '医療事務関係者' },
    { key: 'medical_technologist', label: '臨床検査技師' },
    { key: 'radiological_technologist', label: '診療放射線技師' },
    { key: 'physical_therapist', label: '理学療法士' },
    { key: 'midwife', label: '助産師' },
  ];

  selected: {
    /** 職種 */
    role?: string;
    /** 業種 */
    industryType?: string;
    /** 医師免許資格取得年月日 */
    licenseAcquisitionYear?: string;
    /** 役職 */
    position?: string;
    /** 診療科 */
    departments: string[];
    /** 勤務地 */
    affiliation?: string;
    /** その他医療従事者. 詳細 */
    othersDescription?: string;
    /** 都道府県 */
    pref?: string;
    /** 市区町村番地 */
    address?: string;
    /** 建物名・号室 */
    building?: string;
  } = {
    departments: [],
  };

  base?: {
    givenName: string;
    familyName: string;
    email: string;
    password: string;
    birthdate: {
      year: string;
      month: string;
      date: string;
    };
  };

  constructor() {}

  get isDepartment(): boolean {
    const target = ['doctor', 'nurse'];
    return target.includes(this.selected.role || '');
  }

  get departmentLabel(): string {
    return this.isDepartment ? '診療科' : '専門';
  }
}
